import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_tab = _resolveComponent("v-tab");
    const _component_v_tabs = _resolveComponent("v-tabs");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_tabs, null, {
            default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, key) => {
                    return (_openBlock(), _createBlock(_component_v_tab, {
                        key: key,
                        onClick: ($event) => (_ctx.handleClickTab(key))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
        }),
        _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component)))
        ])
    ]));
}
